
import { ServiceFAQSection } from "@/components/services/ServiceFAQSection";
import { laserDentistryData } from "./laserDentistryData";

export const LaserDentistryFAQ = () => {
  return (
    <ServiceFAQSection
      title="Frequently Asked Questions"
      subtitle="Common Questions"
      faqs={laserDentistryData.faqs}
    />
  );
};
